import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Page404Component } from './page404/page404.component';
import { SanitizeHtmlPipe } from './sanitize.pipe';
import { BlankComponent } from './blank/blank.component';
import { HelpersModule } from './helper/helper.module';
import { RouterLinkDisabledDirective } from './routerlinkdisabled.directive';


@NgModule({
  declarations: [
    Page404Component,
    SanitizeHtmlPipe,
    BlankComponent,
    RouterLinkDisabledDirective
  ],
  imports: [
    HelpersModule,
    RouterModule,
  ],
  providers: [
    SanitizeHtmlPipe
  ],
  exports: [
    RouterModule,
    Page404Component,
    SanitizeHtmlPipe,
    BlankComponent,
    RouterLinkDisabledDirective,
  ],
  /* entryComponents:[ActionPenalComponent] */
})
export class SharedModule { }
